<template>
  <!-- 用户协议 Modal -->
  <div class="modal agreement-modal" v-show="modelShow">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="handClose"></button>
          <h4 class="modal-title tac">好爱学用户协议</h4>
        </div>
        <div class="modal-body">
          <iframe width="100%" height="289" :src="agreementLinks.userAgreement" frameborder="0"></iframe>
        </div>
        <!-- <div class="modal-footer tac">
                    <button type="button" class="btn btn-default" @click="handClose">关闭</button>
                    <button type="button" class="btn btn-bg-primary">提交更改</button>
        </div>-->
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
import fadeAnimate from "common/fade/fadeAnimate";
import agreementLinks from "common/agreement-links";

export default {
  name: "componnetsName",
  props: {
    modelShow: Boolean,
  },
  data() {
    return { agreementLinks };
  },
  components: {
    fadeAnimate,
  },
  methods: {
    handClose() {
      this.$emit("ToggleModal", false);
    },
  },
  computed: {},
  mounted() {
    console.log(this.modelShow);
  },
};
</script>

<style lang='less' scoped>
@import "~style/varibles";
@import "~style/mixins";
.fwb_b_line {
  font-weight: bold;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/page/login/components/login-deal.vue